import React, { useEffect } from 'react'
import RoutesComponent from './user/routes/Routes'
import { ReactNotifications } from 'react-notifications-component'
// Import Bootstrap 5.3.3 configuration
import { initializeBootstrap } from './bootstrap-config'
import './bootstrap-config'
// Import auth styles globally for header
import './styles/auth.css'

function App() {
  useEffect(() => {
    // Initialize Bootstrap components when app loads
    initializeBootstrap();
  }, []);

  return (
    <>
      <ReactNotifications />
      <RoutesComponent />
    </>
  )
}

export default App
